import { issueTicketTypes } from 'constants/issueTickets';

import { PRINT_CUSTOMER_PRESENT_TICKET, PRINT_TICKETS_ATB } from 'store/mutations';
import emailTicketsMutation from './emailTicketsMutation';

const byIssueTicketType = {
  [issueTicketTypes.EMAIL_PDF]: emailTicketsMutation,
  // vv dummy, using same mutation as it's required to have a mutation,
  // but we don't use this for downloading vvvvvvvvvvvv
  [issueTicketTypes.DOWNLOAD_PDF]: emailTicketsMutation,
  [issueTicketTypes.PRINT_ATB]: PRINT_TICKETS_ATB,
  [issueTicketTypes.PRINT_ADYEN_TERMINAL]: PRINT_CUSTOMER_PRESENT_TICKET
};

export { emailTicketsMutation, byIssueTicketType };
